// HeroAnimation.jsx
import { useMemo, useRef } from "react";
import Lottie from "lottie-react";
import rawData from "../../../../assets/animations/hero-right.json";
import "./HeroAnimation.css";

export default function HeroAnimation({ loop = true, autoplay = true }) {
  const ref = useRef();

  // 🔧 Пренасочваме всички image assets към /animations/hero/images/
  const data = useMemo(() => {
    try {
      const cloned = JSON.parse(JSON.stringify(rawData));
      if (Array.isArray(cloned.assets)) {
        cloned.assets = cloned.assets.map(a =>
          a && typeof a === "object" && "u" in a
            ? { ...a, u: "/animations/hero/images/" } // <-- абсолютният път
            : a
        );
      }
      return cloned;
    } catch {
      return rawData;
    }
  }, []);

  return (
    <div className="hero-lottie-wrap">
      <Lottie
        lottieRef={ref}
        animationData={data}
        loop={loop}
        autoplay={autoplay}
        className="hero-lottie"
        renderer="svg"
        rendererSettings={{
          loadImages: true,
          imagePreserveAspectRatio: "xMidYMid meet",
        }}
      />
    </div>
  );
}
